/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type PersonalityType =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H';

export type Prefecture =
  | 'Aichi'
  | 'Akita'
  | 'Aomori'
  | 'Chiba'
  | 'Ehime'
  | 'Fukui'
  | 'Fukuoka'
  | 'Fukushima'
  | 'Gifu'
  | 'Gunma'
  | 'Hiroshima'
  | 'Hokkaido'
  | 'Hyogo'
  | 'Ibaraki'
  | 'Ishikawa'
  | 'Iwate'
  | 'Kagawa'
  | 'Kagoshima'
  | 'Kanagawa'
  | 'Kochi'
  | 'Kumamoto'
  | 'Kyoto'
  | 'Mie'
  | 'Miyagi'
  | 'Miyazaki'
  | 'Nagano'
  | 'Nagasaki'
  | 'Nara'
  | 'Niigata'
  | 'Oita'
  | 'Okayama'
  | 'Okinawa'
  | 'Osaka'
  | 'Saga'
  | 'Saitama'
  | 'Shiga'
  | 'Shimane'
  | 'Shizuoka'
  | 'Tochigi'
  | 'Tokushima'
  | 'Tokyo'
  | 'Tottori'
  | 'Toyama'
  | 'Wakayama'
  | 'Yamagata'
  | 'Yamaguchi'
  | 'Yamanashi';

export type UserGender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type ChatRoomListItemFragment = { id: string, updatedAt: TimeString, status: Types.ChatRoomStatus, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, match: { id: string, isAssigned: boolean, normalMessageChatReplyMatchSetting: { disabledUntil: TimeString | null } }, planner: { id: string, name: string, avatar: any, chatParticipant: { id: string } | null }, user: { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, financialServicesAgent: string | null, karte: { userComment: string } | null, address: { prefecture: string, city: string } | null, diagnosisResult: { personality: { type: Types.PersonalityType, title: string, description: string } } | null } | null, memos: Array<{ id: string, content: string, createdAt: TimeString }> };

export type ChatRoomListUserFragment = { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, financialServicesAgent: string | null, karte: { userComment: string } | null, address: { prefecture: string, city: string } | null, diagnosisResult: { personality: { type: Types.PersonalityType, title: string, description: string } } | null };

export type DiagnosisResultFragment = { personality: { type: Types.PersonalityType, title: string, description: string } };

export const DiagnosisResultFragmentDoc = gql`
    fragment DiagnosisResult on DiagnosisResult {
  personality {
    type
    title
    description
  }
}
    `;
export const ChatRoomListUserFragmentDoc = gql`
    fragment ChatRoomListUser on User {
  id
  karte {
    userComment
  }
  birthYear
  nickname
  gender
  livingPrefecture
  address {
    prefecture
    city
  }
  diagnosisResult {
    ...DiagnosisResult
  }
  financialServicesAgent
}
    ${DiagnosisResultFragmentDoc}`;
export const ChatRoomListItemFragmentDoc = gql`
    fragment ChatRoomListItem on ChatRoom {
  id
  updatedAt
  status
  hasUnreadMessage
  hasUnrepliedMessage
  match {
    id
    isAssigned
    normalMessageChatReplyMatchSetting {
      disabledUntil
    }
  }
  planner {
    id
    name
    avatar
    chatParticipant {
      id
    }
  }
  user {
    ...ChatRoomListUser
  }
  memos {
    id
    content
    createdAt
  }
}
    ${ChatRoomListUserFragmentDoc}`;